// import { useEffect } from "react";
import PropertyImages from "../../../stories/property-detail/property-images";
import PriceLayout from "../../../stories/property-detail/price-layout";
import styles from "../../../../src/pages/property/property-details/property-details.module.scss";
import PropertyDetailHeader from "../../../stories/property-detail/property-detail-header";
// import BidDetailsSkeleton from "../../../skeleton/properties-detail/BidDetails";
import SkeletonC from "../../../stories/common/skeleton";
// import { usePropertyDetail } from "../../../hooks/react-query/properties/usePropertyDetail";
import PropertyDesc from "../../../stories/property-detail/property-description";
import { numberWithCommas } from "../../../utils/const";
// import BidDetails from "../../../stories/property-detail/bid-details";
import PropertyFeatures from "../../../stories/property-detail/property-features";
import { Link, useParams } from "react-router-dom";
import MobileDetailsScreen from "../../../stories/common/mobile-property-details";
import PropertyDocuments from "../../../stories/property-detail/property-documents";
import { useInvestorPropertyDetail } from "../../../hooks/react-query/investor/useInvestorPropertyDetail";
import { OverlayPanel } from "primereact/overlaypanel";
import { useRef } from "react";
import PageTracker from "../../../components/PageTracker";
import React from "react";
import PlaceOfferSkeleton from "../../../skeleton/properties-detail/PlaceOffer";
import ContactAgent from "../../../pages/investor/details/contact-agent";
import Like from "../../common/like";
import { Tag } from "primereact/tag";
import { countDaysFromDate } from "../../../utils/utils";
// import { endSession, startSession } from "../amplitude";

const InvestorPropertyDetails = () => {
  const op = useRef<any>(null);
  const { propertyId } = useParams();
  const { data: objPropertyDetails, isLoading: loading } =
    useInvestorPropertyDetail(`${propertyId}`, "investor");

  return (
    <>
      <MobileDetailsScreen
        type={"investor"}
        objPropertyDetails={objPropertyDetails}
        isLoading={loading}
      />
      <div className={styles.propertyDetails}>
        <div className={`${styles.content}`}>
          {!objPropertyDetails?.id || loading ? (
            <div className={styles.propertyHeader}>
              <SkeletonC
                width="28%"
                height="24px"
                className={styles.skeleton}
                shape="rectangle"
              />
              <SkeletonC
                width="24px"
                height="24px"
                shape="circle"
                className={styles.skeleton}
              />
            </div>
          ) : (
            <div className={styles.propertyHeader}>
              <PageTracker
                shareId={propertyId || ""}
                propertyId={objPropertyDetails?.id}
                pageName={"Investor Property Details"}
                objPropertyDetails={objPropertyDetails}
              />
              <PropertyDetailHeader
                address={`${objPropertyDetails?.address ?? ""}`}
              />

              <div className={styles.shareDetails}>
                {/* <ButtonC
                  type="button"
                  className={styles.ContactSupport}
                  icon="share"
                  label="Contact Support"
                  onClick={(e: any) => op?.current?.toggle(e)}
                /> */}
                <i
                  style={{ cursor: "pointer" }}
                  className="pi pi-question-circle"
                  onClick={(e: any) => op?.current?.toggle(e)}
                ></i>
                {objPropertyDetails?.id && (
                  <Like
                    loginType={"investor"}
                    propertyId={objPropertyDetails.id}
                    favCount={objPropertyDetails?.favCount}
                    objPropertyDetails={objPropertyDetails}
                    width={24}
                  />
                )}
                <OverlayPanel
                  ref={op}
                  closeOnEscape
                  dismissable
                  className={styles.dialog}
                >
                  <div className={styles.header}>Technical support</div>
                  <div className={styles.content}>
                    Email us at{" "}
                    <Link to="mailto:support@ftreca.com">
                      support@ftreca.com
                    </Link>{" "}
                    for technical support
                  </div>
                </OverlayPanel>
              </div>
            </div>
          )}
          <div className={styles.propertyContentWrap}>
            {!objPropertyDetails?.id || loading ? (
              <SkeletonC
                width="100%"
                height="535px"
                borderRadius="17.95px"
                className={styles.skeleton}
              />
            ) : (
              <>
                <div className={styles.statusWrap}>
                  {/* <Tag
                    value={
                      countDaysFromDate(objPropertyDetails?.createdAt) > 1
                        ? `${countDaysFromDate(
                            objPropertyDetails?.createdAt
                          )} Days ago`
                        : `${countDaysFromDate(
                            objPropertyDetails?.createdAt
                          )} Day ago`
                    }
                    style={{
                      background: "#0000008a",
                      color: "#ffffff"
                    }}
                    className={styles.dayCount}
                  /> */}
                </div>
                <PropertyImages
                  imagesArr={objPropertyDetails?.images?.filter(
                    (value: any) => value?.url
                  )}
                  type={"investor"}
                  propertyId={propertyId}
                  objPropertyDetails={objPropertyDetails}
                />
              </>
            )}
            <div className={styles.propertyWrap}>
              <div className={styles.propertyDescription}>
                {!objPropertyDetails?.id || loading ? (
                  <>
                    <SkeletonC
                      width="25%"
                      height="50px"
                      className={styles.skeleton}
                    />
                    <SkeletonC
                      width="35%"
                      height="30px"
                      className={styles.skeleton}
                    />
                    <SkeletonC
                      width="40%"
                      height="30px"
                      className={styles.skeleton}
                    />
                  </>
                ) : (
                  <PriceLayout
                    type={"investor"}
                    priceDrop={objPropertyDetails?.priceDrop}
                    priceDropDate={objPropertyDetails?.priceDropDate}
                    amount={objPropertyDetails?.askingPrice}
                    currencyCode="USD"
                    locale="en-US"
                    house={objPropertyDetails?.objPriceLayout?.house}
                    sqft={
                      objPropertyDetails?.lotSizeSqFt > 0
                        ? numberWithCommas(objPropertyDetails?.lotSizeSqFt)
                        : null
                    }
                    bed={
                      objPropertyDetails?.beds || objPropertyDetails?.bedRooms
                    }
                    bath={
                      objPropertyDetails?.baths || objPropertyDetails?.totalBath
                    }
                    garage={objPropertyDetails?.garage}
                    sqftText="SQFT"
                    address={objPropertyDetails?.address}
                  />
                )}

                {!objPropertyDetails?.id || loading ? (
                  <SkeletonC
                    width="100%"
                    height="7rem"
                    className="mb-2 "
                    shape="rectangle"
                  />
                ) : (
                  <PropertyDesc
                    type={"investor"}
                    title={"Property Description"}
                    propertyDetails={objPropertyDetails?.description}
                    viewMoreWords={250}
                  />
                )}
                {objPropertyDetails?.docs?.length > 0 && (
                  <PropertyDocuments
                    type={"investor"}
                    title={"Documents"}
                    objPropertyDetails={objPropertyDetails}
                    loading={!objPropertyDetails?.id || loading}
                    shareId={propertyId}
                  />
                )}
                {/* {loading ? (
                <BidDetailsSkeleton />
              ) : (
                <BidDetails
                  title={"Bid Details"}
                  dateTimeTitle={"Showing Date and Time"}
                  dateTime={objPropertyDetails?.showingDateAndTime}
                  company={"BS Escrow Company"}
                  company_subtitle={objPropertyDetails?.bsEscrowCompany}
                  offersDueTitle={"Offer Due Date and Time"}
                  offersDateTime={objPropertyDetails?.offerDueDateAndTime}
                  closeTitle={"Close Date and Time"}
                  closeDate={objPropertyDetails?.closeDate}
                  depositTitle={"BS Deposit"}
                  amount={objPropertyDetails?.bsDeposit}
                  currencyCode="USD"
                  locale="en-US"
                  sales={"Sales Instructions"}
                  salesInstruction={objPropertyDetails?.salesInstruction}
                />
              )} */}
                {(objPropertyDetails?.bedRooms ||
                  objPropertyDetails?.beds ||
                  objPropertyDetails?.baths ||
                  objPropertyDetails?.totalBath ||
                  objPropertyDetails?.lotSizeSqFt ||
                  objPropertyDetails?.yearBuilt) && (
                  <PropertyFeatures
                    type={"investor"}
                    title={"Property Features"}
                    objPropertyDetails={objPropertyDetails}
                    minShowData={4}
                    loading={!objPropertyDetails?.id || loading}
                  />
                )}
              </div>
              <div className={styles.agentBox}>
                <div className={styles.placeOffer}>
                  {loading ? (
                    <PlaceOfferSkeleton />
                  ) : (
                    <>
                      <ContactAgent objPropertyDetails={objPropertyDetails} />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(InvestorPropertyDetails);
